import i18next from 'i18next'
import { z } from 'zod'

import { emptySelectOptionZod, SelectOptionZod, selectOptionZod } from 'components/Select'
import { DomainAmazonOption } from './hooks/useGetDomainAmazons'

export const adUnitAmazonsAttributes = z.record(z.string(), z.boolean())

export const schema = z.object({
  adUnitAmazonsAttributes,
  enabled: z.boolean(),
  id: selectOptionZod<DomainAmazonOption>().refine(
    (value: SelectOptionZod<DomainAmazonOption>): boolean => value.value !== '',
    i18next.t('common:form.error.nonEmpty'),
  ),
})

export type AdUnitAmazons = z.infer<typeof adUnitAmazonsAttributes>
export type Schema = z.infer<typeof schema>

export const schemaDefaults: Schema = {
  adUnitAmazonsAttributes: {},
  enabled: false,
  id: emptySelectOptionZod<DomainAmazonOption>(),
}
